<template>
  <div class="container" style="margin-top: 100px">
    <h2 class="text-center">
      Contact Me
    </h2>
    <div class="grid-3_xs-1_sm-2_md-2" v-if="contacts.length">
      <div
        v-for="(contact, index) in contacts"
        :key="index"
        class="col"
      >
        <a :href="contact.link" target="_blank">
          <Card class="center">
            <template #title>
              <h3>{{ contact.name }}</h3>
            </template>
            <template #content>
              <p>
                {{ contact.value }}
              </p>
            </template>
          </Card>
        </a>
      </div>
    </div>
    <Nothing />
  </div>
</template>

<script>
import Nothing from '@/components/Nothing.vue'
import Card from 'primevue/card'

export default {
  name: 'Contacts',
  computed: {
    contacts: function () {
      return this.getConfig().contacts
    }
  },
  components: {
    Nothing,
    Card
  }
}
</script>
